export default __webpack_public_path__ + "static/media/deno.96d4a63d.svg";